@if (config) {
<div class="dr-card">

  <!-- Brillo decorativo -->
  <div class="dr-card__glow"></div>

  <!-- Header -->
  <div class="dr-card__header">
    <span class="dr-card__dot"></span>
    <h4 class="dr-card__title">{{ config.title }}</h4>
    <span class="dr-card__count">{{ rows.length }}</span>
  </div>

  <!-- Lista -->
  <div class="dr-card__list">
    @for (row of rows; track row.rank) {
    <div class="dr-row">

      <!-- Rank + medalla -->
      <div class="dr-row__rank">
        @if (row.medal) {
          <span class="dr-row__medal">{{ row.medal }}</span>
        } @else {
          <span class="dr-row__num">{{ row.rank }}</span>
        }
      </div>

      <!-- Nombre + barra -->
      <div class="dr-row__main">
        <div class="dr-row__top">
          <span class="dr-row__name">{{ row.name }}</span>
          <div class="dr-row__right">
            <span class="dr-row__value" [style.color]="row.barColor">
              {{ formatValue(row.value) }}
            </span>
            @if (config.valueLabel) {
              <span class="dr-row__unit">{{ config.valueLabel }}</span>
            }
            @if (row.pct !== undefined) {
              <span class="dr-row__pct" [style.color]="row.barColor">
                {{ row.pct | number:'1.1-1' }}%
              </span>
            }
          </div>
        </div>

        @if (row.sublabel) {
          <span class="dr-row__sublabel">{{ row.sublabel }}</span>
        }

        <!-- Barra animada -->
        <div class="dr-row__track">
          <div class="dr-row__fill"
               [style.width.%]="row.barPct"
               [style.background]="row.barColor"
               [style.box-shadow]="'0 0 6px ' + row.barColor + '66'">
          </div>
        </div>
      </div>

    </div>
    }
  </div>

</div>
}
